import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEditBig: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconEditBig"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H12V5H5V19H19V12H21V21H3V3Z" fill="currentColor"/><Path d="M22.4142 6.00015L18 1.58594L8 11.5859V16.0002H12.4142L22.4142 6.00015Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEditBig;
